"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleGeneralError = exports.handleErrorToolUnavailable = exports.handleErrorForbidden = exports.handleError500 = exports.ACTIONS = void 0;

var _ = require(".");

var ACTIONS = {
  FORBIDDEN: new _.Action('FORBIDDEN'),
  TOOL_UNAVAILABLE: new _.Action('TOOL_UNAVAILABLE'),
  ERROR_500: new _.Action('ERROR_500'),
  GENERAL_ERROR: new _.Action('GENERAL_ERROR')
};
exports.ACTIONS = ACTIONS;

var handleError500 = function handleError500() {
  return {
    type: ACTIONS.ERROR_500.main
  };
};

exports.handleError500 = handleError500;

var handleErrorForbidden = function handleErrorForbidden() {
  return {
    type: ACTIONS.FORBIDDEN.main
  };
};

exports.handleErrorForbidden = handleErrorForbidden;

var handleErrorToolUnavailable = function handleErrorToolUnavailable() {
  return {
    type: ACTIONS.TOOL_UNAVAILABLE.main
  };
};

exports.handleErrorToolUnavailable = handleErrorToolUnavailable;

var handleGeneralError = function handleGeneralError(message) {
  return {
    type: ACTIONS.GENERAL_ERROR.main,
    payload: {
      message: message
    }
  };
};

exports.handleGeneralError = handleGeneralError;